<template>
    <div class="text-xs-center">
        <v-dialog
                @keydown.esc="disagreeButton"
                persistent
                v-model="$store.getters.errorMessageModal"
                width="500">
            <v-card>
                <v-card-title
                        class="headline secondary white--text justify-center"
                        primary-title>
                    Προσοχή
                </v-card-title>

                <v-card-text v-html = $store.getters.errorMessageObject.message>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            @click="disagreeButton"
                            color="primary"
                            flat>
                        Κλείσιμο
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        name: "ErrorMessageComponent",
        data() {
            return {}
        },
        methods: {
            disagreeButton() {
                var message =  this.$store.getters.errorMessageObject.message;
                if (message.indexOf("http://") > -1 || message.indexOf("https://") > -1) {
                    window.location.replace(' http://service.eudoxus.gr/student/');
                }
                else {
                    this.$store.commit('setErrorMessageModal', false);
                }
            }
        }
    }
</script>

<style scoped>

</style>